import MenuIcon from '@mui/icons-material/Menu'
import { Tab, TabProps, Tabs, TabsProps, styled } from '@mui/material'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import Toolbar from '@mui/material/Toolbar'
import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import Logo from '../../../images/logo.svg'

import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { isBusinessURL } from '../../../_helpers/routes'
import { ITab } from '../../../_models/tabsInterface'
import LanguageSelector from '../../../components/languageSelector'
import {
  fadeInAnimation,
  fadeInWithDelayAnimation,
} from '../../../pages/common/landingPage/animations'
import { headerTabs } from '../items'
interface IHeader {
  children: React.ReactNode
  handleDrawerToggle: () => void
}

const CustomTabs = styled(Tabs)<TabsProps>(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  paddingLeft: 0,
  paddingRight: 0,
  '& .indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    height: '.1875rem',
    '& > span': {
      width: '80%',
      backgroundColor: theme.palette.primary.main,
      height: '.1875rem',
    },
  },
  '& .flexContainer': {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'fit-content',
  },
}))

const CustomTab = styled(Tab)<TabProps>(({ theme }) => ({
  borderRadius: '0.625rem',
  minHeight: 'initial',
  '&.Mui-selected': {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    fontWeight: 500,
  },
  ...fadeInAnimation,
}))

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

const PublicHeader: React.FC<IHeader> = ({ handleDrawerToggle, children }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [value, setValue] = React.useState<number | false>(false)
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }
  const handleClickTab = (id: number) => {
    document.body.classList.remove('no-scroll')
    const isBusiness = isBusinessURL()
    const baseBusinessUrl = `${window.location.protocol}//${process.env.REACT_APP_BUSINESS_URL}`
    let path = ''
    switch (id) {
      case 1:
        path = 'features'
        break
      case 2:
        path = 'coming-soon'
        break
      case 3:
        path = 'contact-us'
        break
    }

    const url = isBusiness ? `${baseBusinessUrl}/${path}` : `/${path}`
    isBusiness ? window.location.replace(url) : navigate(url)
  }

  const checkPath = () => {
    switch (window.location.pathname) {
      case '/features':
        setValue(0)
        break
      case '/coming-soon':
        setValue(1)
        break
      case '/contact-us':
        setValue(2)
        break
      case '/':
        setValue(false)
        break
      default:
        setValue(false)
        break
    }
  }

  useEffect(() => {
    checkPath()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname])

  return (
    <>
      <Box
        sx={{
          display: 'flex',
        }}
      >
        <AppBar
          component='nav'
          sx={{
            p: 1,

            margin: '0 auto',
            left: 0,
            right: 0,
          }}
        >
          <Toolbar>
            <Box
              component='div'
              sx={{
                flexGrow: { xs: 1, lg: 0 },
                maxWidth: '90rem',
                ml: { lg: 12 },
                mr: { lg: 8 },
                display: { sm: 'block' },
                textAlign: { xs: 'left', sm: 'left', md: 'left', lg: 'left' },
                cursor: 'pointer',
                ...fadeInWithDelayAnimation,
              }}
              onClick={() =>
                isBusinessURL()
                  ? window.location.replace(
                      `${window.location.protocol}//${process.env.REACT_APP_BUSINESS_URL}/`,
                    )
                  : navigate('/')
              }
            >
              <img src={Logo} alt='' />
            </Box>
            <Box
              sx={{
                display: { xs: 'none', lg: 'flex' },
                flexGrow: 1,
                justifyContent: 'space-between',
              }}
            >
              <CustomTabs
                value={value}
                onChange={handleChange}
                aria-label='profile settings tabs'
                indicatorColor='primary'
                classes={{ indicator: 'indicator' }}
                TabIndicatorProps={{ children: <span /> }}
                sx={{ px: { sm: 0, md: 0, lg: 1 }, py: 2 }}
              >
                {headerTabs.map((item: ITab, index: number) => {
                  return (
                    <CustomTab
                      sx={{
                        backgroundColor: 'common.white',
                        color: 'secondary.main',
                        fontWeight: 'normal',
                        fontSize: '1rem',
                        mx: { sm: 0, md: 2, lg: 2 },
                      }}
                      key={index}
                      label={t(`publicLayout.${item.label}`)}
                      onClick={() => handleClickTab(item.id)}
                      {...a11yProps(index)}
                    />
                  )
                })}
              </CustomTabs>
              {/* <Box display={'flex'} justifyContent={'end'} mt={1.7}>
                <Box
                  sx={{
                    px: { sm: 2, md: 2 },
                    mx: { sm: 1, md: 2 },
                    mt: { sm: 1, md: 1 },
                    pointerEvents: 'none',
                    opacity: 0.5,
                  }}
                >
                  <LanguageSelector />
                </Box>
                <Button
                  variant='outlined'
                  disabled
                  sx={{
                    mx: 1,
                    px: { sm: 2, md: 4 },
                    height: 44,
                    fontSize: '1rem',
                    ...fadeInAnimation,
                  }}
                >
                  {t('publicLayout.signInBtn')}
                </Button>

                <Button
                  variant='contained'
                  disabled
                  sx={{
                    px: { sm: 2, md: 4 },
                    mx: { sm: 1, md: 2 },
                    height: 44,
                    fontSize: '1rem',
                    ...fadeInAnimation,
                  }}
                >
                  {t('publicLayout.startFreeButton')}
                </Button>
              </Box> */}
            </Box>
            <IconButton
              color='primary'
              aria-label='open drawer'
              edge='start'
              size='large'
              onClick={handleDrawerToggle}
              sx={{ display: { lg: 'none' } }}
            >
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Box mt={9.2}>{children}</Box>
      </Box>
    </>
  )
}
export default PublicHeader
